module.exports = __webpack_public_path__ + "img/quality_icon_blue.0509ca82.svg";